import React from 'react';
import { LoadingIndicator } from './status';

export type PortalDataStateKind = 'loading' | 'first-empty' | 'context-empty' | 'failed' | 'restricted';

interface PortalDataStateProps {
  kind: PortalDataStateKind;
  heading: string;
  message: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
}

/** Honest, reusable presentation for durable Portal data regions. */
export const PortalDataState = ({
  kind,
  heading,
  message,
  action,
  compact = false
}: PortalDataStateProps): JSX.Element => {
  if (kind === 'loading') {
    return (
      <div className={`portal-data-state${compact ? ' portal-data-state--compact' : ''}`}>
        <LoadingIndicator label={heading} />
        <div className="muted">{message}</div>
      </div>
    );
  }

  return (
    <section
      className={`portal-data-state portal-data-state--${kind}${compact ? ' portal-data-state--compact' : ''}`}
      aria-live={kind === 'failed' ? 'polite' : undefined}
    >
      <h3>{heading}</h3>
      <div className="muted">{message}</div>
      {action && <div className="portal-data-state__action">{action}</div>}
    </section>
  );
};

